// Tutti mark (from the Tutti Glass design): horizontal voices converging into one point = 합주.
export function Logo({ size = 32 }: { size?: number }) {
  return (
    <svg className="logo" width={size} height={size} viewBox="0 0 34 34" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="tutti-logo-grad" x1="6" y1="8" x2="24" y2="26" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6366f1" />
          <stop offset="1" stopColor="#22d3ee" />
        </linearGradient>
      </defs>
      <circle cx="24" cy="17" r="5.6" fill="url(#tutti-logo-grad)" opacity="0.15" />
      <g stroke="url(#tutti-logo-grad)" strokeWidth="2.1" strokeLinecap="round">
        <path d="M6 9H11C17 9 19 13 22.7 16.4" opacity="0.6" />
        <path d="M6 17H22.8" />
        <path d="M6 25H11C17 25 19 21 22.7 17.6" opacity="0.6" />
      </g>
      <circle cx="24" cy="17" r="2.6" fill="url(#tutti-logo-grad)" />
    </svg>
  );
}
